// DillySocks Adventskalender-PDP (Saison-Template).
// Umbau 11.09.2026 (Sean-Briefing): kein Format-Umschalter mehr (Standard-
// und Paar-Kalender sind zwei getrennte PDPs), keine JS-Preisrechnung mehr
// (Preis + Streichpreis kommen direkt vom Produkt, manuell gepflegt).
// Bleibt: Early-Bird-Countdown, Groessenwahl (mit Auto-Select bei nur einer
// Groesse — Paar-PDP), Warenkorb-Add ueber Horizons Event-System.
// Neu: Newsletter-Feld -> Klaviyo-Subscribe + Rabattcode unsichtbar an die
// Session haengen (/discount/CODE, kein sichtbarer Code).
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  function init(root) {
    if (!root || root.dataset.dsInit) return;
    root.dataset.dsInit = '1';

    var dataEl = root.querySelector('[data-ds-adv-data]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : null;
    if (!data) return;

    var state = { variantId: null };

    // ---- Early-Bird-Countdown (reine Anzeige) ---------------------------
    var eb = root.querySelector('[data-ds-adv-eb]');
    if (eb) {
      var end = new Date(eb.dataset.end || 0).getTime();
      var units = eb.querySelectorAll('[data-cd-u]');
      var timer = setInterval(tick, 1000);
      function tick() {
        var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (diff <= 0) {
          eb.hidden = true;
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400); diff -= d * 86400;
        var h = Math.floor(diff / 3600); diff -= h * 3600;
        var m = Math.floor(diff / 60); var s = diff - m * 60;
        var vals = [d, h, m, s];
        units.forEach(function (u, i) { u.textContent = String(vals[i]).padStart(2, '0'); });
      }
      tick();
    }

    // ---- Groessenwahl ----------------------------------------------------
    var errEl = root.querySelector('[data-ds-adv-err]');
    var sizeBtns = root.querySelectorAll('[data-ds-adv-size]');
    // Sean 16.09.: keine Vorauswahl (auch nicht bei nur einer Groesse wie
    // der Paar-PDP) — die Kund:in waehlt aktiv; zweiter Klick waehlt ab.
    function selectSize(btn) {
      var deselect = btn.dataset.active === 'true';
      sizeBtns.forEach(function (x) { x.dataset.active = (x === btn && !deselect) ? 'true' : 'false'; });
      state.variantId = deselect ? null : btn.dataset.dsAdvSize;
      if (errEl && !deselect) errEl.hidden = true;
    }
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        // Ausverkaufte Groessen gehoeren ds-back-in-stock.js (Couvert-Pille)
        if (b.classList.contains('ds-bis-advsize')) return;
        selectSize(b);
      });
    });

    // ---- Verfuegbarkeit / Button-Zustand --------------------------------
    var addBtn = root.querySelector('[data-ds-adv-add]');
    if (addBtn && !data.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Ausverkauft';
    }
    var stickyPrice = root.querySelector('[data-ds-adv-sticky-price]');
    if (stickyPrice && typeof window.dsMoney === 'function') {
      stickyPrice.textContent = window.dsMoney(data.price);
    }

    // ---- In den Warenkorb ------------------------------------------------
    // Zustandstexte kommen als data-Attribute aus dem Liquid (Locale-Keys
    // ds_advent.buy.*), damit sie in Translate & Adapt uebersetzbar sind.
    if (addBtn) {
      addBtn.addEventListener('click', async function () {
        if (!data.available) return;
        if (!state.variantId) {
          if (errEl) errEl.hidden = false;
          return;
        }
        addBtn.disabled = true;
        var orig = addBtn.innerHTML;
        addBtn.innerHTML = addBtn.dataset.dsAdvAdding || 'Wird hinzugefügt …';

        var deferred = CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: state.variantId, quantity: 1 }],
          promise: deferred.promise,
        }));

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(state.variantId, 10), quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('add failed');
          var ajaxCart = await (await fetch('/cart.js')).json();
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: { items: ajaxCart.items, itemCount: ajaxCart.item_count, didError: false },
          });
          addBtn.innerHTML = addBtn.dataset.dsAdvAdded || 'Zum Warenkorb hinzugefügt ✓';
          setTimeout(function () { addBtn.innerHTML = orig; addBtn.disabled = false; }, 2500);
        } catch (e) {
          deferred.resolve({ detail: { didError: true } });
          addBtn.innerHTML = addBtn.dataset.dsAdvError || 'Fehler – bitte erneut versuchen';
          addBtn.disabled = false;
        }
      });
    }

    // ---- Newsletter-Rabatt ----------------------------------------------
    // Klaviyo-Subscribe (Client-API, wie ds-aw26-hero.js), danach den
    // Rabattcode UNSICHTBAR an die Session haengen: GET /discount/CODE
    // setzt Shopifys discount_code-Cookie; an der Kasse wird er
    // automatisch angewendet. Kein Code im UI (Briefing Punkt 6).
    var nl = root.querySelector('[data-ds-adv-nl]');
    if (nl) {
      var nlForm = nl.querySelector('[data-ds-adv-nl-form]');
      var nlMsg = nl.querySelector('[data-ds-adv-nl-msg]');
      var cfgEl = nl.querySelector('[data-ds-adv-nl-config]');
      var cfg = {};
      try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) {}
      var texts = {
        success: nl.dataset.success || '',
        error: nl.dataset.error || ''
      };
      nlForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var input = nlForm.querySelector('input[type="email"]');
        var email = (input.value || '').trim();
        var showMsg = function (txt, ok) {
          nlMsg.hidden = false;
          nlMsg.textContent = txt;
          nlMsg.className = 'ds-adv__nl-msg ' + (ok ? 'is-success' : 'is-error');
        };
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showMsg(texts.error, false);
          input.focus();
          return;
        }
        var btn = nlForm.querySelector('button[type="submit"]');
        btn.disabled = true;

        var applyCode = function () {
          var code = nl.dataset.code || '';
          if (!code) return Promise.resolve();
          // Response ist ein Redirect auf die Startseite — Inhalt egal,
          // wichtig ist nur das gesetzte Discount-Cookie.
          return fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
        };

        var subscribe = Promise.resolve();
        if (cfg.publicKey && cfg.listId) {
          var payload = {
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: cfg.listId } } }
            }
          };
          // Gleiche API-Version und Content-Type wie das Hero-Newsletter-
          // Script (ds-aw26-hero.js): Mit der alten Revision 2024-10-15
          // lehnte Klaviyo das verschachtelte "subscriptions"-Feld mit 400
          // ab -> Anmeldung zeigte immer die Fehlermeldung (Sean 16.09.).
          subscribe = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + cfg.publicKey, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
            body: JSON.stringify(payload)
          }).then(function (res) {
            if (!(res.status === 202 || res.ok)) throw new Error('subscribe ' + res.status);
          });
        }

        subscribe
          .then(applyCode)
          .then(function () {
            showMsg(texts.success, true);
            nlForm.hidden = true;
          })
          .catch(function () {
            showMsg(texts.error, false);
            btn.disabled = false;
          });
      });
    }

    // ---- Scroll-CTAs ("Jetzt sichern" / "Jetzt verschenken") -------------
    // WICHTIG (Sean 11.09.): window.scrollTo funktioniert hier NICHT —
    // Horizon scrollt in .page-wrapper, html/body stehen auf
    // overflow: hidden. scrollIntoView sucht sich den passenden
    // Scroll-Container selbst und funktioniert in beiden Faellen.
    root.querySelectorAll('[data-ds-adv-top]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = root.querySelector('.ds-adv__main') || root;
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ds-advent]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
